import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react'

import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Menu } from '@mui/material'

import images from '../../../../../assets/images'
import styles from './FilterMenu.styles'
import { FilterMenuHandle, FilterMenuProps } from './FilterMenu.types'

const { FilterIcon } = images

const FilterMenu = forwardRef<FilterMenuHandle, FilterMenuProps>((props, ref) => {
  const { children, icon, removeContentPadding, isMenuOpen, setIsMenuOpen } = props

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [isOpen, setIsOpen] = React.useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    setIsOpen(true)
    setIsMenuOpen?.(true)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setIsOpen(false)
    setIsMenuOpen?.(false)
  }

  // Expose the close method to parent components
  useImperativeHandle(ref, () => ({
    close: handleClose
  }))

  useEffect(() => {
    if (isMenuOpen && !isOpen && buttonRef.current) {
      // If menu should be open but isn't, set the anchor element
      setAnchorEl(buttonRef.current)
      setIsOpen(true)
    } else if (!isMenuOpen && isOpen) {
      // If menu should be closed but isn't, remove the anchor element
      setAnchorEl(null)
      setIsOpen(false)
    }
  }, [isMenuOpen, isOpen])

  return (
    <Box>
      <Box>
        <IconButton onClick={handleMenuOpen} sx={styles.icon} ref={buttonRef}>
          {isOpen ? <CloseIcon sx={styles.closeIcon} /> : icon ?? <FilterIcon />}
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={isOpen}
          onClose={handleClose}
          slotProps={{
            paper: styles.paper
          }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          sx={styles.menu(removeContentPadding)}
        >
          {children}
        </Menu>
      </Box>
    </Box>
  )
})

export default FilterMenu
